export const ALL_LESSONS_KEY = 'All Lessons'
